export const roles = (state = [], action) => {
  if (action.type === 'FETCH_ROLES') {
    return action.payload;
  }
  if (action.type === 'CLEAR_ROLES') {
    return [];
  }
  return state;
};

export const role = (state = {}, action) => {
  if (action.type === 'FETCH_ROLE') {
    return action.payload;
  }
  if (action.type === 'CLEAR_ROLE') {
    return {};
  }
  return state;
};

export const roleIds = (state = [], action) => {
  if (action.type === 'FETCH_ROLE_IDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_ROLE_IDS') {
    return [];
  }
  return state;
};
